"use client";

import { ReactNode } from "react";
import { apiPlugin, storyblokInit } from "@storyblok/react";

import Page from "@/components/Page";
import Hero from "@/components/Hero";
import PageTargetDefense from "@/components/PageTargetDefense";
import Footer from "@/components/layouts/Footer";
import TrustSmall from "@/components/layouts/TrustSmall";
import Accreditors from "@/components/layouts/Accreditors";
import QuoteForm from "@/components/QuoteForm";
import Feature from "@/components/Feature";
import ServiceSection from "@/components/ServiceSection";
import StickySubnav from "@/components/layouts/StickySubnav";
import Header from "@/components/layouts/Header";
import ReferenceSelector from "@/components/ReferenceSelector";
import Qualifications from "@/components/Qualifications";
import TrustedTopBrands from "@/components/TrustedTopBrands";
import ContactSection from "@/components/ContactSection";
import ContactSocial from "@/components/ContactSocial";
import BlogIntro from "@/components/BlogIntro";
import BlogContent from "@/components/BlogContent";
import BlogConclusion from "@/components/BlogConclusion";
import BlogAuthor from "@/components/BlogAuthor";
import BlogLearnMore from "@/components/BlogLearnMore";
import HeroBlogPost from "@/components/HeroBlogPost";
import FeaturedTop from "@/components/FeaturedTop";
import FeaturedBottom from "@/components/FeaturedBottom";
import WhySection from "@/components/WhySection";
import BenefitSection from "@/components/BenefitSection";
import DifferentTypeSection from "@/components/DifferentSection";
import GetFastQuote from "@/components/GetFastQuote";
import FaqSection from "@/components/FaqSection";
import PenetrationTestingSection from "@/components/PenetrationTestingSection";
import MeetPenTest from "@/components/MeetPenTest";
import FeatureStatisticSection from "@/components/FeatureStatisticSection";
import BannerCaseStudy from "@/components/BannerCaseStudy";
import RelatedResources from "@/components/RelatedResources";
import TabSection from "@/components/TabSection";
import MethodologySection from "@/components/MethodologySection";
import QuoteOneLine from "@/components/QuoteOneLine";
import TopBrandsSection from "@/components/TopBrandsSection";
import OvsTypeSection from "@/components/OvsTypeSection";
import VideoContent from "@/components/VideoContent";
import PackageSection from "@/components/PackageSection";
import ExpertSection from "@/components/ExpertSection";
import DownloadCardIndustryReports from "@/components/DownloadCardIndustryReports";
import BlockquoteAuthor from "@/components/BlockquoteAuthor";
import TermsContent from "@/components/TermsContent";
import DownloadForm from "@/components/DownloadForm";

const components = {
  page: Page,
  page_target_defense: PageTargetDefense,
  footer_target_defense: Footer,
  header_target_defense: Header,
  accreditation_small_section: TrustSmall,
  accreditation_big_section: Accreditors,
  hero: Hero,
  hero_blog_post: HeroBlogPost,
  feature: Feature,
  service_section: ServiceSection,
  quote_form: QuoteForm,
  stickynav_target_defense: StickySubnav,
  reference_selector: ReferenceSelector,
  trusted_by_top_brands: TrustedTopBrands,
  qualifications: Qualifications,
  contact_section: ContactSection,
  contact_social: ContactSocial,
  blog_details: BlogIntro,
  blog_content: BlogContent,
  blog_conclusion: BlogConclusion,
  blog_author: BlogAuthor,
  blog_learn_more: BlogLearnMore,
  featured_top: FeaturedTop,
  featured_bottom: FeaturedBottom,
  why_section: WhySection,
  benefit_section: BenefitSection,
  different_type_section: DifferentTypeSection,
  get_fast_quote: GetFastQuote,
  faq_section: FaqSection,
  penetration_testing_section: PenetrationTestingSection,
  meet_pen_test: MeetPenTest,
  feature_statistic_section: FeatureStatisticSection,
  banner_case_study: BannerCaseStudy,
  related_resources: RelatedResources,
  tab_section: TabSection,
  methodology_section: MethodologySection,
  quote_one_line: QuoteOneLine,
  top_brands_section: TopBrandsSection,
  ovs_type_section: OvsTypeSection,
  video_content: VideoContent,
  package_section: PackageSection,
  expert_section: ExpertSection,
  download_card_section: DownloadCardIndustryReports,
  blockquote_author: BlockquoteAuthor,
  terms_content: TermsContent,
  download_form: DownloadForm,
};

storyblokInit({
  accessToken: process.env.NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN,
  use: [apiPlugin],
  bridge: process.env.NEXT_PUBLIC_NODE_ENV === 'development',
  components,
  apiOptions: {
    region: 'eu',
    cache: {
      type: 'none',
      clear: 'auto'
    }
  }
});

interface StoryblokProviderProps {
  children: ReactNode;
}

const _StoryblokProvider: React.FC<StoryblokProviderProps> = ({ children }) => {
  return <>{children}</>;
};

export default _StoryblokProvider;
